// import { SafeHtml } from '@angular/platform-browser';
// import { TimeSlot, UserPaymentMeansRequest } from 'app/shared/models/request.models';
// import { environment } from 'environments/environment';
import { CountryCode, CountryCallingCode } from 'libphonenumber-js/mobile';
import { environment } from "../../../environments/environment";
import { HttpStatusCode } from "@angular/common/http";

export class OmniServiceBaseResponse {
  data: any;
  error: { errorCode: number, errorMessage: string, action: { name: string, url: string } | null } | null;
  statusCode: HttpStatusCode;
  generatedIn: string;

  constructor(
    data: any,
    error: {
      errorCode: number;
      errorMessage: string;
      action: { name: string; url: string } | null
    } | null,
    statusCode: HttpStatusCode,
    generatedIn: string
  ) {
    this.data = data;
    this.error = error;
    this.statusCode = statusCode;
    this.generatedIn = generatedIn;
  }
}

//
// export class ValueDisplayModel {
//   value: string;
//   display: string;
// }
//
// // Vehicle Model
// export class Vehicle {
//   VehicleId: number;
//   NumberPlate: string;
//   StateOfRegistration: string;
//   Label: string;
//   VehicleStatus: string;
//   Barcode: string;
//   ParkingHistory: string;
//   NominatedForAutoPayment: boolean;
// }
//
// export class VehicleStandardPlateRsp {
//   IsStandard: boolean;
//   ConfirmMessage: string;
// }
//
// export class VehicleExport {
//   Registration: string;
//   StateOfRegistration: string;
//   Status: string;
// }
//
// // Motorist Model
// export class Motorist {
//   MotoristId: number;
//   ParkingTagAccountId: number;
//   MotoristStatus: string;
//   Label: string;
//   PhoneNumber: string;
//   PrimaryVehicleId: number;
//   SmsReminderOption: number;
//   DrivingReminderOption: number;
//   TimeSlots: TimeSlot[];
// }
//
// export class MotoristExport {
//   PhoneNumber: string;
//   ParkingReminder: string;
//   // DrivingReminder: string;
//   NominatedVehicle: string;
// }
//
// // Promotion Model
// export class PromotionDisplay {
//   PromotionId: number;
//   Name: string;
//   Active: boolean;
//   StartTime: Date;
//   EndTime: Date;
//   TimeProfileId: number;
//   CompactBannerURL: string;
//   LargeBannerURL: string;
//   Description: string;
//   ParkingAuthorityIds: number[];
//   TimeSlots: TimeSlot[];
//   ParkingPromotionRules: ParkingPromotionRule[];
// }
//
// export class Promotion {
//   Name: string;
//   PromotionId: number;
//   Description: string;
//   Token: string;
//   Active: boolean;
//   CreatedByUserName: String;
//   StartTime: any;
//   EndTime: any;
//   TimeProfileId: number;
//   CompactBannerURL: string;
//   LargeBannerURL: string;
//   LastUsedTime: Date;
//   CountCapDailyPending: number;
//   AmountCapDailyPending: number;
//   CountCapDailyProcessed: number;
//   AmountCapDailyProcessed: number;
//   CountCapTotalPending: number;
//   AmountCapTotalPending: number;
//   CountCapTotalProcessed: number;
//   AmountCapTotalProcessed: number;
//   CountDaily: number;
//   AmountDaily: number;
//   CountTotal: number;
//   AmountTotal: number;
//   IsExclusive: boolean;
//   AutoApply: boolean;
//   ParkingPromotionRules: ParkingPromotionRule[];
//   TimeSlots: TimeSlot[];
//   SingleDayApply: boolean;
// }
//
//
// export class ParkingPromotionRule {
//   RuleId: number;
//   Active: boolean;
//   ParkingAuthority: ParkingAuthority;
//   ZoneIds: number[];
//   Zones: string[];
//   DiscountPerHour: string;
//   DiscountCap?: number;
//   UserClaim: string;
//   UserClaimKey: string;
// }
//
// export class AddParkingPromotionRule {
//   RuleId: number;
//   Active: boolean;
//   ParkingAuthority: ParkingAuthority;
//   isZoneChecked: boolean;
//   ZoneIds: number[];
//   Zones: string[];
//   DiscountPerHour: string;
//   DiscountCap?: number;
//   UserClaim: string;
//   UserClaimKey: string;
// }
//
// export class ParkingAuthority {
//   ClientLogoURl: string;
//   Image: string;
//   Links: string;
//   Name: string;
//   ParkingAuthorityId: number;
//   PrepaidStartTime: Date;
//   ZonePrefix: string;
//   isExternalProvider: boolean;
// }
//
// export class PromotionDisplayDetails {
//   PromotionsDisplayList: PromotionDisplay[];
//   ParkingAuthorityList: ParkingAuthority[];
// }
//
//
// export class Zone {
//   ZoneId: number;
//   Name: string;
//   ShortName: string;
//   ParkingAuthorityId: number;
//   ParkingAuthorityName: string;
//   ClientLogoURL: string; // Change History: TT-99893
//   Tariff: Tariff;
//   OffstreetParkingDetails: OffstreetParkingDetails;
//   DurationSliderDefault: number;
//   AllowPrepaidParking: boolean;
//   AllowDurationSelect: boolean;
//   IsLastTicketOverStayed: boolean;
//   IsOfflineZone: boolean;
//   PreBookHoursInAdvance: number;
//   PreInitiateMessage: string;
//   PostInitiateMessage: string;
//   Offset: number;
//   ProviderDetails: ProviderDetails;
//   PromotionDetails: PromotionDetails;
//   PreBookDayTicket: boolean;
//   PromotionsEligible: boolean;
//   SurchargeToDisplay?: string;
//   CustomTariffDisplayString?: any;
//   FreeParkingMessage: string;
//   GuestHideStateSelection: boolean;
//
//   static isZoneFree(zone:Zone): boolean {
//     if (zone.IsOfflineZone === true) {
//       const offstreetParkingCost = zone.OffstreetParkingDetails.Amount * 100;
//       return offstreetParkingCost === 0;
//     }
//
//     return zone.Tariff == null;
//   }
// }
//
// export class ProviderDetails {
//   ProviderName: string;
//   Link: string
//   IsUserLinkedWithProvider: boolean;
// }
//
// export class PromotionDetails {
//   PromotionName: string;
//   DiscountPerHour: string;
//   DiscountCap?: number;
//   DiscountedCostPerHour: string;
// }
//
// export class TopUpThreshold {
//   Amount: number;
//   Description: string;
// }
//
// export class TopUpAmount {
//   TopUpAmountId: number;
//   Amount: number;
//   Description: string;
// }
//
// export class Tariff {
//   CurrentDate: Date;
//   MinStay: number;
//   MaxStay: number;
//   CappedParking: boolean;
//   CostPerHour: string;
//   CostCap: number;
//   PermittedDurations: string;
//   TariffType: number;
//   StartTime?: string
//   EndTime?: string
// }
//
// export class OffstreetParkingDetails {
//   EntryTime: Date;
//   Amount: number;
//   Duration: number;
// }
//
// export class Ticket {
//   TicketId: number;
//   TicketStatus: string;
//   ZoneName: string;
//   ZoneDescription: string;
//   TicketStartTime: Date;
//   TicketEndTime: Date;
//   TicketInitiated: Date;
//   DiscountInCents: number;
//   Duration: number;
//   Balance: number;
//   SmsReminder: boolean;
//   DrivingReminder: boolean;
//   ParkingCost: number;
//   VehicleId: number;
//   VehicleLabel: string;
//   VehicleNumberPlate: string;
//   MotoristId: number;
//   AllowStopParking: boolean;
//   IsOfflineZone: boolean;
//   Barcode: string;
//   InvoiceID?: string;
//   StateOfRegistration?: string; // Used locally in frontend only, not currently returned by backend
// }
//
// export class IRole {
//   Name: String;
//   Level: number;
//   IsAdministrator: boolean;
//   IsPrivileged: boolean;
// }
//
// export class IProfile {
//   ProfileId: number;
//   ProfileName: string;
//   ProfileDescription: string;
//   GenesisRoleName: string;
//   RequiresClient: boolean;
//   RequiresVerification: boolean;
//   APIProfile: boolean;
// }
//
// export class GenesisUser {
//
//   protected static SInit = (() => {
//     GenesisUser.prototype.UserId = 0;
//     GenesisUser.prototype.Status = 0;
//     GenesisUser.prototype.UserName = "";
//     GenesisUser.prototype.RoleList = [];
//     GenesisUser.prototype.UserNameIsEMailAddress = false;
//     GenesisUser.prototype.LockedOut = 0;
//     GenesisUser.prototype.FirstName = "";
//     GenesisUser.prototype.LastName = "";
//     GenesisUser.prototype.AddressLines = [];
//     GenesisUser.prototype.Town = "";
//     GenesisUser.prototype.City = "";
//     GenesisUser.prototype.County = "";
//     GenesisUser.prototype.YearOfBirth = 0;
//     GenesisUser.prototype.PostCode = "";
//     GenesisUser.prototype.Country = "";
//     GenesisUser.prototype.PasswordHint = "";
//     GenesisUser.prototype.EMails = [];
//     GenesisUser.prototype.MobilePhones = [];
//     GenesisUser.prototype.OptInMarketing = null;
//     GenesisUser.prototype.TwoFactorEnabled = null;
//     GenesisUser.prototype.DisableActivationEmail = false;
//     GenesisUser.prototype.LinkreferenceId = null;
//   })();
//
//   UserId: number;
//   Status: number;
//   UserName: string;
//   RoleList: IRole[];
//   UserNameIsEMailAddress: boolean;
//   LockedOut: number;
//   FirstName: string;
//   LastName: string;
//   AddressLines: string[];
//   Town: string;
//   City: string;
//   County: string;
//   YearOfBirth: number;
//   PostCode: string;
//   Country: string;
//   PasswordHint: string;
//   EMails: any;
//   MobilePhones: any;
//   OptInMarketing: boolean;
//   TwoFactorEnabled: boolean;
//   DisableActivationEmail: boolean;
//   LinkreferenceId: string;
// }
//
// export class PaymentMean {
//   protected static SInit = (() => {
//     PaymentMean.prototype.Account = 0;
//     PaymentMean.prototype.PaymentProviderId = 0;
//     PaymentMean.prototype.Balance = 0;
//     PaymentMean.prototype.CardType = "";
//     PaymentMean.prototype.CardHolderName = "";
//     PaymentMean.prototype.CardNumber = "";
//     PaymentMean.prototype.CardExpiry = "";
//     PaymentMean.prototype.MinBalance = 0;
//     PaymentMean.prototype.TopUp = 0;
//     PaymentMean.prototype.LastUpdateStatus = "";
//     PaymentMean.prototype.PaymentMethod = "CARD_PAYMENT";
//   })();
//
//
//   PaymentProviderId: number;
//   Account: number;
//   Balance: number;  // in dollars
//   CardType: string;
//   CardHolderName: string;
//   CardNumber: string;
//   CardExpiry: string;
//   MinBalance: number;
//   TopUp: number;
//   LastUpdateStatus: string;
//   PaymentMethod: PaymentType;
// }
//
// export class Transaction {
//   TransactionID: string;
//   TransactionDateTime: Date;
//   TransactionTypeCode: string;
//   TotalAmount: number;
//   IsRefunded: number;
//   ResponseCode: string;
//   LicencePlate: string;
//   StateOfRegistration: string;
//   MobileNumber: string;
//   StartTime: Date;
//   EndTime: Date;
//   MethodOfCapture: number;
//   TransactionNumber: number;
//   ExternalTransactionID: string;
//   PaymentTransactionID: string;
//   Cashier: string;
//   RunningBalance: string;
//   ZoneId: number;
//   ZoneName: string;
//   ZoneNumber: string; // this would be ZoneName but that's taken by a description
//   Description: string;
//   Discount: number;
//   OriginalCost: number;
//   RefundDescription: string;
//   Currency: string;
// }
//
// export class MenuItem {
//   menuname: string;
//   display: string;
//   isActive: boolean;
//   relativeLink: string;
//   loadDefaultSubMenu?: number;
//   subMenus: MenuItem[];
//   imagePath?: string;
//   parameterKeys?: string[];
//   requireLogIn?: boolean;
// }
//
// export class UserReview {
//   Rate: number;
//   Header: string;
//   Content: string;
//   Name: string;
// }
//
// export class communicationData {
//   clientName: string;
//   header: string;
//   bodyInHtml: string;
//   footer: string;
//   imagePath: string;
// }
//
// export class GuestTicketModel {
//   ZoneName: string;
//   MobileNumber: string;
//   NumberPlate: string;
//   StateOfRegistration: string;
//   TicketStartTime: string | Date;
//   TicketEndTime: string;
//   // UserPaymentMeansRequest: UserPaymentMeansRequest;
//   EmailAddress: string;
//   Duration: number;
//   PxPayResponse: string;
//   PaymentResponse: string|any;
//   PaymentType: PaymentType;
//   SuccessURL: string;
//   FailureURL: string;
//   VirtualMeterId?: string;
//   InitialisationType?: string;
// }
//
// export class GuestParkingDetails extends GuestTicketModel {
//   Cost: number;
//   CountryCodeIndex: string;
// }
//
// export class DeleteAccountRequest {
//   EmailAddress: string;
//   MobileNumber: string;
//   NumberPlate: string;
// }
//
// export class ParkingCostRequest {
//   PhoneNumber: string;
//   ZoneName: string;
//   LicencePlate: string;
//   StateOfRegistration: string;
//   StartTime: Date;
//   DurationInMinutes: number;
//   IsGuestTicket?: boolean;
// }
export class CountryDetails {
  countryCode: CountryCode;
  countryExtension: CountryCallingCode;

  constructor(countryCode: CountryCode, countryExtension: CountryCallingCode) {
    this.countryCode = countryCode;
    this.countryExtension = countryExtension;
  }
}
//
// export class KeyboardEventExtension extends KeyboardEvent {
//   target: EventTargetExtension;
// }
//
// export class EventTargetExtension extends EventTarget {
//   selectionStart: number;
//   selectionEnd: number;
// }
export type PaymentType = "CARD_PAYMENT" | "APPLE"| "GOOGLE"| "VISA"| "ZIP_MONEY" | "APPLEPAYWEB" | "CLICK_TO_PAY";
// export class SerializedPaymentResponse {
//   PaymentResponse: string;
//   PaymentType: PaymentType;
// }

export class FzPaymentIntent {
  payment: FzPayment;
  verification: string; // hash - from backend only

  constructor(payment: FzPayment, verification: string) {
    this.payment = payment;
    this.verification = verification;
  }
}
export class FzPayment {
  amount: number; //cents
  currency: string; // ISO-4217 country code
  reference: string; // TBD unique payment ref
  hide_card_holder?: boolean;

  constructor(amount: number, currency: string, reference: string, hide_card_holder?: boolean) {
    this.amount = amount;
    this.currency = currency;
    this.reference = reference;
    this.hide_card_holder = hide_card_holder;
  }
}

export class FzPaymentResponse {
  message: string;
  errors: string[];
  data: FzPaymentResponseData;

  constructor(message: string, errors: string[], data: FzPaymentResponseData) {
    this.message = message;
    this.errors = errors;
    this.data = data;
  }
}
export class FzPaymentResponseData {
  transactionId: string;
  responseCode: string;
  message: string;
  amount: number;
  currency: string;
  reference: string;
  cardNumber: string;
  cardHolder: string;
  cardExpiry: string;
  cardType: string;
  verification: string;
  token: string;

  constructor(
    transactionId: string,
    responseCode: string,
    message: string,
    amount: number,
    currency: string,
    reference: string,
    cardNumber: string,
    cardHolder: string,
    cardExpiry: string,
    cardType: string,
    verification: string,
    token: string
  ) {
    this.transactionId = transactionId;
    this.responseCode = responseCode;
    this.message = message;
    this.amount = amount;
    this.currency = currency;
    this.reference = reference;
    this.cardNumber = cardNumber;
    this.cardHolder = cardHolder;
    this.cardExpiry = cardExpiry;
    this.cardType = cardType;
    this.verification = verification;
    this.token = token;
  }
}

export class CTPPaymentResponse {
  message: string;
  errors: string[];
  CostInCents: number;
  currency: string;
  paymentVerification : string;
  cardType:string;
  CTPDetails: any;
  CTPResponse:any;
  CardDetails: any;

  constructor(
    message: string,
    errors: string[],
    CostInCents: number,
    currency: string,
    paymentVerification: string,
    cardType: string,
    CTPDetails: any,
    CTPResponse: any,
    CardDetails: any
  ) {
    this.message = message;
    this.errors = errors;
    this.CostInCents = CostInCents;
    this.currency = currency;
    this.paymentVerification = paymentVerification;
    this.cardType = cardType;
    this.CTPDetails = CTPDetails;
    this.CTPResponse = CTPResponse;
    this.CardDetails = CardDetails;
  }
}

export class GooglePayObject {

  public static instance: GooglePayObject = new GooglePayObject();

  baseRequest: any;
  baseCardPaymentMethod: any;
  methods: any[];
  tokenizationSpecification: any;
  allowedCardNetworks: string[];
  allowedCardAuthMethods: string[];
  cardPaymentMethod: any;

  private constructor() {
    this.baseRequest = {
      apiVersion: 2,
      apiVersionMinor: 0,
      merchantInfo: {
        merchantName: environment.googlePayMerchantName,
        merchantId: environment.googlePayMerchantId
      }
    };

    this.tokenizationSpecification = {
      type: 'PAYMENT_GATEWAY',
      parameters: {
        gateway: environment.googlePayGatewayName,
        gatewayMerchantId: environment.googlePayGatewayMerchantId
      }
    };

    this.allowedCardNetworks = ["MASTERCARD", "VISA"];

    if (environment.amexEnabled) {
      this.allowedCardNetworks.push("AMEX");
    }

    this.allowedCardAuthMethods = ["PAN_ONLY"];

    this.baseCardPaymentMethod = {
      type: 'CARD',
      parameters: {
        allowedAuthMethods: this.allowedCardAuthMethods,
        allowedCardNetworks: this.allowedCardNetworks
      }
    };

    this.cardPaymentMethod = Object.assign(
      this.baseCardPaymentMethod,
      { tokenizationSpecification: this.tokenizationSpecification }
    );

    this.methods = [this.baseCardPaymentMethod];
  }
}

export enum ApplePayPaymentAuthorisationStatus {
  STATUS_SUCCESS = 0,
  STATUS_FAILURE = 1
}

export class PaymentDataRequest {
  apiVersion: number;
  apiVersionMinor: number;
  merchantInfo: any;
  allowedPaymentMethods: any[];
  transactionInfo: any;
  callbackIntents: string[];
  offerInfo: any;
  emailRequired: boolean;
  shippingAddressRequired: boolean;
  shippingAddressParameters: any;
  shippingOptionRequired: boolean;
  shippingOptionParameters: any[];

  constructor(apiVersion: number, apiVersionMinor: number, merchantInfo: any, allowedPaymentMethods: any[], transactionInfo: any, callbackIntents: string[], offerInfo: any, emailRequired: boolean, shippingAddressRequired: boolean, shippingAddressParameters: any, shippingOptionRequired: boolean, shippingOptionParameters: any[]) {
    this.apiVersion = apiVersion;
    this.apiVersionMinor = apiVersionMinor;
    this.merchantInfo = merchantInfo;
    this.allowedPaymentMethods = allowedPaymentMethods;
    this.transactionInfo = transactionInfo;
    this.callbackIntents = callbackIntents;
    this.offerInfo = offerInfo;
    this.emailRequired = emailRequired;
    this.shippingAddressRequired = shippingAddressRequired;
    this.shippingAddressParameters = shippingAddressParameters;
    this.shippingOptionRequired = shippingOptionRequired;
    this.shippingOptionParameters = shippingOptionParameters;
  }
}

export class BasicPaymentDetails {
  amountInCents: number;
  currency: string;

  constructor(amountInCents: number, currency: string) {
    this.amountInCents = amountInCents;
    this.currency = currency;
  }

  getDollarString(): string {
    return (this.amountInCents / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(",", "");
  }
}

export class FzClickToPayIntent {
  payment: FzClickToPay;
  verification: string; // hash - from backend only

  constructor(payment: FzClickToPay, verification: string) {
    this.payment = payment;
    this.verification = verification;
  }
}
export class FzClickToPay {
  amount: number; //decimal
  currency: string; // ISO-4217 country code
  reference: string; // TBD unique payment ref

  constructor(amount: number, currency: string, reference: string) {
    this.amount = amount;
    this.currency = currency;
    this.reference = reference;
  }
}
export class OmnichannelModel {
  LocationOrNumberPlate: string;
  TicketStartTime: string | Date;
  TicketEndTime: string;
  Duration: number;
  PxPayResponse: string;
  PaymentResponse: string|any;
  PaymentType: PaymentType;
  SuccessURL: string;
  FailureURL: string;
  VirtualMeterId?: string;
  InitialisationType?: string;
  HashValue: string;

  constructor(LocationOrNumberPlate: string, TicketStartTime: string | Date, TicketEndTime: string, Duration: number, PxPayResponse: string, PaymentResponse: any, PaymentType: PaymentType, SuccessURL: string, FailureURL: string, VirtualMeterId: string, InitialisationType: string, HashValue: string) {
    this.LocationOrNumberPlate = LocationOrNumberPlate;
    this.TicketStartTime = TicketStartTime;
    this.TicketEndTime = TicketEndTime;
    this.Duration = Duration;
    this.PxPayResponse = PxPayResponse;
    this.PaymentResponse = PaymentResponse;
    this.PaymentType = PaymentType;
    this.SuccessURL = SuccessURL;
    this.FailureURL = FailureURL;
    this.VirtualMeterId = VirtualMeterId;
    this.InitialisationType = InitialisationType;
    this.HashValue = HashValue;
  }
}

export class SessionDetails {
  //id: number;
  amount: number;
  currency: string;
  omniSessionId: string;
  tenantCode: string;
  currentSessionCount: number;
  expiryDate: Date;
  location?: string;
  machineId: string;
  machineTimezoneName: string;
  regoPlate: string;
  phoneNumber?: string;
  startDate: Date;
  extensionAvailable: boolean;
  virtualMachineId: string;

  constructor(amount: number, currency: string, omniSessionId: string, tenantCode: string, currentSessionCount: number, expiryDate: Date, location: string, machineId: string, machineTimezoneName: string, regoPlate: string, phoneNumber: string, startDate: Date, extensionAvailable: boolean, virtualMachineId: string) {
    this.amount = amount;
    this.currency = currency;
    this.omniSessionId = omniSessionId;
    this.tenantCode = tenantCode;
    this.currentSessionCount = currentSessionCount;
    this.expiryDate = expiryDate;
    this.location = location;
    this.machineId = machineId;
    this.machineTimezoneName = machineTimezoneName;
    this.regoPlate = regoPlate;
    this.phoneNumber = phoneNumber;
    this.startDate = startDate;
    this.extensionAvailable = extensionAvailable;
    this.virtualMachineId = virtualMachineId;
  }
}
export type ReceiptDetails = Blob

export class AddMobileResponse{

  constructor() {}
}

export class ThemeModel {
  primaryColour: string;
  secondaryColour: string;
  logoURL: string | null;

  constructor(primaryColour: string, secondaryColour: string, logoURL: string | null) {
    this.primaryColour = primaryColour;
    this.secondaryColour = secondaryColour;
    this.logoURL = logoURL;
  }
}

export class ProcessedPayment {
  costInCents: number;
  amount: number;
  durationInMinutes: number;
  paymentReference: string;
  currency: string;
  verification: string;
  cssUrl: string;
  cssVerification: string;
  tokenizeOnly: boolean;
  auth: boolean;
  paymentVerification: string;

  constructor(
    costInCents: number,
    amount: number,
    durationInMinutes: number,
    paymentReference: string,
    currency: string,
    verification: string,
    cssUrl: string,
    cssVerification: string,
    tokenizeOnly: boolean,
    auth: boolean,
    paymentVerification: string
  ) {
    this.costInCents = costInCents;
    this.amount = amount;
    this.durationInMinutes = durationInMinutes;
    this.paymentReference = paymentReference;
    this.currency = currency;
    this.verification = verification;
    this.cssUrl = cssUrl;
    this.cssVerification = cssVerification;
    this.tokenizeOnly = tokenizeOnly;
    this.auth = auth;
    this.paymentVerification = paymentVerification;
  }
}

export class SessionRate{
  price: number;
  expiry: Date;
  endReached: boolean;
  duration: number;
  parkingFees: Array<ParkingFee>;

  constructor(price: number, expiry: Date, endReached: boolean, duration: number, parkingFees: Array<ParkingFee>) {
    this.price = price;
    this.expiry = expiry;
    this.endReached = endReached;
    this.duration = duration;
    this.parkingFees = parkingFees;
  }
}

export class ParkingFee{
  fee?: number;
  gst?: number;
  name: string;
  // total: number;

  constructor(name: string, fee?: number, gst?: number) {
    this.name = name;
    this.fee = fee;
    this.gst = gst;
  }
}

export class TariffRate{
  name: string;
  tariffType: number;
  prices: Array<SessionRate>;

  constructor(name: string, tariffType: number, prices: Array<SessionRate>) {
    this.name = name;
    this.tariffType = tariffType;
    this.prices = prices;
  }
}

export class CheckExtension{
  extensionAvailable: boolean;
  virtualMachineId: string;
  plate: string;
  paidUntil: Date;
  currencyCode: string;
  priceSets: Array<TariffRate>;

  constructor(
    extensionAvailable: boolean,
    virtualMachineId: string,
    plate: string,
    paidUntil: Date,
    currencyCode: string,
    priceSets: Array<TariffRate>
  ) {
    this.extensionAvailable = extensionAvailable;
    this.virtualMachineId = virtualMachineId;
    this.plate = plate;
    this.paidUntil = paidUntil;
    this.currencyCode = currencyCode;
    this.priceSets = priceSets;
  }
}

export class OmniTicket {
  id: number;
  partition: number;
  omniSessionId: string;
  tenantCode: string;
  sessionId: string;
  currentSessionCount: number;
  amount: number;
  expiryDate: string;
  location: string;
  machineId: string;
  machineTimezoneName: string;
  regoPlate: string;
  phoneNumber: string;
  startDate: string;
  addedDate: string;
  virtualMachineId: string;
  //smsTransactions: null;

  constructor(id: number, partition: number, omniSessionId: string, tenantCode: string, sessionId: string, currentSessionCount: number, amount: number, expiryDate: string, location: string, machineId: string, machineTimezoneName: string, regoPlate: string, phoneNumber: string, startDate: string, addedDate: string, virtualMachineId: string) {
    this.id = id;
    this.partition = partition;
    this.omniSessionId = omniSessionId;
    this.tenantCode = tenantCode;
    this.sessionId = sessionId;
    this.currentSessionCount = currentSessionCount;
    this.amount = amount;
    this.expiryDate = expiryDate;
    this.location = location;
    this.machineId = machineId;
    this.machineTimezoneName = machineTimezoneName;
    this.regoPlate = regoPlate;
    this.phoneNumber = phoneNumber;
    this.startDate = startDate;
    this.addedDate = addedDate;
    this.virtualMachineId = virtualMachineId;
  }
}

export class ExtensionResponse {
  expiryDate: Date;
  amount: number;

  constructor(expiryDate: Date, amount: number) {
    this.expiryDate = expiryDate;
    this.amount = amount;
  }
}
